import React from 'react';
import { ChecronButton } from './ChevronButton';
import { DefaultButton } from './DefaultButton';

const Button = ({ type, ...props }) => {
  const generateButton = () => {
    const defaultBtn = <DefaultButton {...props} />;

    switch (type) {
      case 'left-chevron':
        return <ChecronButton {...props} />;

      default:
        return defaultBtn;
    }
  };

  return <>{generateButton()}</>;
};

export default Button;
